<template>
  <PVToolbar :aria-labelledby="ariaLabelledby">
    <template
      v-if="slots.start"
      #start
    >
      <slot name="start" />
    </template>
    <template
      v-if="slots.center"
      #center
    >
      <slot name="center" />
    </template>
    <template
      v-if="slots.end"
      #end
    >
      <slot name="end" />
    </template>
  </PVToolbar>
</template>

<script lang="ts">
export default {
  name: 'StandardToolbar',
  compatConfig: { MODE: 3 },
};
</script>

<script setup lang="ts">
import { useSlots } from 'vue';

defineProps<{
  ariaLabelledby?: string;
}>();

const slots = useSlots();
</script>
